import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'

import makeAjaxRequest from '../makeAjaxRequest'

export const ERROR_KEYS = {
  400: {
    key: 'common.error.unknown',
  },
  401: {
    key: 'captcha.error.expired_token',
  },
  422: {
    key: 'captcha.error.invalid_format',
  },
  default: {
    key: 'common.error.unknown',
  },
}

export default () =>
  makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    url: `${APIGATEWAY_BASE_URL}/v1/captcha/password-reset`,
    verb: 'GET',
  }).then((response) => {
    const captchaConfig = { provider: response.provider, siteKey: response.site_key }
    return captchaConfig
  })
